import { render } from "./ActivityPanelDetailsPanelFooter.vue?vue&type=template&id=3a8c5f58&scoped=true"
import script from "./ActivityPanelDetailsPanelFooter.vue?vue&type=script&lang=js"
export * from "./ActivityPanelDetailsPanelFooter.vue?vue&type=script&lang=js"

import "./ActivityPanelDetailsPanelFooter.vue?vue&type=style&index=0&id=3a8c5f58&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8c5f58"]])

export default __exports__